import { useEffect, useState } from "react";

export default function SongComponent({songId}) {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(()=>{
    // Load Spotify iFrame API
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://open.spotify.com/embed/iframe-api/v1';
    document.head.appendChild(script);

    // Create Spotify Controller
    window.onSpotifyIframeApiReady = (IFrameAPI) => {
      const element = document.getElementById('embed-iframe');
      const options = {
          uri: 'spotify:track:' + songId,
          height: '80',
          width: '100%',
          class: 'post-song',
          // load: 'lazy',
          theme: 'dark',
        };
      const callback = (EmbedController) => {
        window.addEventListener('load', (e)=> {
          console.log('loaded');
          EmbedController.loadUri('spotify:track:' + songId)
          EmbedController.play();
        })
      };
      IFrameAPI.createController(element, options, callback);
    };
    // if (isOpen == false) {
    //   document.head.removeChild(script);
    //   delete window.onSpotifyIframeApiReady;
    //   delete window.SpotifyIframeConfig;
    // }
    return () => {
      document.head.removeChild(script);
      delete window.onSpotifyIframeApiReady;
      delete window.SpotifyIframeConfig;
    }
  },[songId])

  function handleClose() {
    // setIsOpen(false);
    delete window.onSpotifyIframeApiReady;
    delete window.SpotifyIframeConfig;
    document.querySelector('.post-song-wrapper').remove();
    document.querySelector('.post-item-wrapper').style.marginBottom = '0px';
  }

  return (
    <div className="post-song-wrapper">
      <div className="close" 
        onClick={()=>handleClose()}
        // onClick={(e) => {e.target.parentNode.parentNode.remove();}}
      >Close Spotify</div>
      <div className="post-song-card">
        <div id="embed-iframe"></div>
      </div>
    </div>
  );
}
